import React from 'react';
import Hero from './components/about-us/governance/Hero';
import Main from './components/about-us/governance/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Governance = () => {
  return (
    <div>
        <Hero />
        <Main />
        <ImportantLinksSlider />
    </div>
  )
}

export default Governance;